import React, { FC } from 'react';

import { IconProps } from 'types/components';

import Icon from './Icon';

const ArrowLeft: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path d="M11.71 5.29a1 1 0 0 1 0 1.42L7.41 11H19a1 1 0 0 1 0 2H7.41l4.3 4.29a1 1 0 0 1-1.42 1.42l-6-6a1 1 0 0 1 0-1.42l6-6a1 1 0 0 1 1.42 0Z" />
  </Icon>
);

export default ArrowLeft;
